import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaBell, FaExclamationCircle, FaUsersCog, FaHeadset, FaCog } from "react-icons/fa";
import MenuIcon from "./MenuIcon";

import "../styles/Sidebar.css";

const Sidebar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }

    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    console.log('🟢 Toggle mobile menu clicked. Current state:', isMobileMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
    console.log('🟢 New state will be:', !isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  const menuItems = [
    { name: "Tableau de bord", icon: <MenuIcon iconName="_Icon_-17" alt="Dashboard" />, path: "/dashboard" },
    { name: "Clients", icon: <MenuIcon iconName="_Icon_-18" alt="Clients" />, path: "/clients" },
    { name: "Prestataires", icon: <MenuIcon iconName="_Icon_-18" alt="Prestataires" />, path: "/prestataires" },
    { name: "Missions", icon: <MenuIcon iconName="_Icon_-20" alt="Missions" />, path: "/missions" },
    { name: "Signalements", icon: <FaExclamationCircle />, path: "/signalements" },
    { name: "Paiements", icon: <MenuIcon iconName="_Icon_-25" alt="Paiements" />, path: "/paiements" },
    { name: "Services", icon: <MenuIcon iconName="_Icon_-22" alt="Services" />, path: "/services" },
    { name: "Vehicules", icon: <MenuIcon iconName="_Icon_-24" alt="Vehicules" />, path: "/vehicules" },
    { name: "Abonnements", icon: <MenuIcon iconName="_Icon_-21" alt="Abonnements" />, path: "/abonnements" },
    { name: "Publicité & Visibilité", icon: <MenuIcon iconName="_Icon_-26" alt="Publicité" />, path: "/publicite" },
    { name: "Validation Documents", icon: <MenuIcon iconName="_Icon_-19" alt="Validation" />, path: "/validation-documents" },
    { name: "Utilisateurs Internes", icon: <FaUsersCog />, path: "/utilisateurs-internes" },
    { name: "Notifications", icon: <FaBell />, path: "/notifications" },
    { name: "Support Client", icon: <FaHeadset />, path: "/support" },
    { name: "Paramètres", icon: <FaCog />, path: "/parametres" },
  ];

  console.log('🔍 Sidebar render - isMobile:', isMobile, 'isMobileMenuOpen:', isMobileMenuOpen);

  return (
    <>
      {isMobile && (
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      )}
      
      {isMobile && isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu} />
      )}
      
      <div className={`sidebar ${isMobile ? 'sidebar-mobile' : ''} ${isMobileMenuOpen ? 'sidebar-open' : ''}`}>
        {isMobile && (
          <div className="sidebar-header">
            <h2>WaaGo</h2>
            <button className="close-sidebar" onClick={closeMobileMenu}>
              <FaTimes />
            </button>
          </div>
        )}
        
        <ul>
          {menuItems.map((item) => (
            <li key={item.name}>
              <NavLink 
                to={item.path} 
                className={({ isActive }) => isActive ? "active" : ""}
                onClick={isMobile ? closeMobileMenu : undefined}
              >
                {item.icon}
                <span>{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
